import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from './template/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from './template/layout/core'
import {MasterInit} from './template/layout/MasterInit'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <Outlet />
          <MasterInit />
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
